/* eslint-disable prettier/prettier */
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/Button';
import NotFoundImage from '../assets/error-404.svg';

type NotFoundPageProps = {
  message?: string;
  buttonLabel?: string;
  buttonAction?: () => void;
};

export const NotFoundPage = ({
  message,
  buttonLabel,
  buttonAction,
}: NotFoundPageProps) => {
  const navigate = useNavigate();

  return (
    <div className="flex items-center justify-center min-h-screen px-4 bg-light">
      <div className="flex flex-col items-center text-center">
        <img
          src={NotFoundImage}
          alt="404 not found"
          className="h-auto mx-auto w-90"
        />
        <h1 className="mb-3 text-4xl font-extrabold text-primary">Page not found</h1>
        <p className="mb-6 text-lg text-muted-foreground">
          {message || "The page you're looking for doesn't exist."}
        </p>
        <Button onClick={buttonAction || (() => navigate('/'))}>
          {buttonLabel || 'Go back'}
        </Button>
      </div>
    </div>
  );
};
